import {
  MDBAccordion,
  MDBAccordionItem,
  MDBAlert,
  MDBBadge,
  MDBBtn,
  MDBIcon, MDBModal, MDBCollapse, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle, MDBTooltip,
  MDBSpinner,
} from 'mdb-react-ui-kit';
import { React, useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import { browserName, browserVersion } from "react-device-detect";

import { Link, useLocation, useNavigate } from "react-router-dom";
import report from '../components/images/reportlogo.svg';
import {
  endBussinessSession,
  getGBussinessInfo,
  getPricingPlansById,
  getStaffProfile,
  getWhatsappApi,
  logEvent,
  sendVEmail,
  getmultigyms,
  getAllSubDomain,
  getRoleAccess,
  getStaffByGym,
  getwhatsAppPartnerInfo,
  saveGBussinessInfo,
  emailVerify,
} from "../services/apiServices";
import logo from "./../components/images/Easy-MembrLogo.png";
import Popup from "./Popup";
import businessImg from "./images/Business.svg";
import checkImg from "./images/Checkin.svg";
import SegmentsIcon from "./images/SegmentsIcon.svg";
import logOutImg from "./images/Logout.svg";
import membersImg from "./images/Members.svg";
import memShipImg from "./images/Membership.svg";
import remaindersImg from "./images/Reminders.svg";
import settingsImg from "./images/Settings.svg";
import staffImg from "./images/Staff.svg";
import transcImg from "./images/Transactions.svg";
import event from "./images/activity-svgrepo-com.svg";
import dashImg from "./images/dashboard.svg";
import posImg from "./images/point-of-sale.svg";
import globeImg from './images/website.svg'
import sucessImg from "./images/succes_icon.svg";
import axios from 'axios';
import GenerateNewPassword from './GenerateNewPassword';
import { useAnalytics } from '../hooks/useAnalytics';
import { useAccess } from '../context/AccessContext';

const SIDEBAR_SCROLL_KEY = "gymLeftSidebarScrollY";

export default function LeftPane(props) {
  const { trackButtonClick } = useAnalytics();
  // const [userInfo, setUserInfo] = useState("");
  const [plansInfo, setPlansInfo] = useState(localStorage.getItem("planInfo") ? JSON.parse(localStorage.getItem("planInfo")) : null)
  // let plansInfo = localStorage.getItem("planInfo") ? JSON.parse(localStorage.getItem("planInfo")) : null;
  const logourl = (localStorage.getItem("loggedUserInfo") ? (JSON.parse(localStorage.getItem("loggedUserInfo")).gymlogoUrl ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymlogoUrl : logo) : logo)
  const [imageLoaded, setImageLoaded] = useState(true);
  const bussName = (localStorage.getItem("loggedUserInfo") ? (JSON.parse(localStorage.getItem("loggedUserInfo")).gymname) : "");
  const [menuClass, setMenuClass] = useState(
    "gym-sidebar gym-red gym-top gym-medium gym-padding gym-collapse "
  );
  const navigate = useNavigate();
  const [enagleGym, setEnagleGym] = useState(true);
  const [isSignupEnabled, setIsSignupEnabled] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [noPlanpopup, setnoPlanpopup] = useState(false);
  const { roleAccess, loading, rolename } = useAccess();
  const loggedUserInfo = JSON.parse(localStorage.getItem("loggedUserInfo"));
  const [whatsAppapiCheck, setWhatsAppapiCheck] = useState(false)

  const [showNewPasswordPop, setShowNewPasswordPop] = useState(true);
  const [Error2, setError2] = useState("")
  const [mdata, setMdata] = useState([])
  const [selectedBusiness, setSelectedBusiness] = useState(null);
  const [selectedGym, setSelectedGym] = useState("");

  const [logos, setlogos] = useState("")
  const [isWhatsAppOpen, setIsWhatsAppOpen] = useState(props.isactive === "16" ? true : false);
  const location = useLocation();
  const sidebarRef = useRef(null);

  const persistSidebarScroll = useCallback(() => {
    const el = sidebarRef.current;
    if (!el) return;
    try {
      sessionStorage.setItem(SIDEBAR_SCROLL_KEY, String(el.scrollTop));
    } catch (e) {
      /* ignore */
    }
  }, []);

  useLayoutEffect(() => {
    if (loading) return;
    const el = sidebarRef.current;
    if (!el) return;
    const applyScroll = () => {
      try {
        const raw = sessionStorage.getItem(SIDEBAR_SCROLL_KEY);
        if (raw == null || raw === "") return;
        const y = parseInt(raw, 10);
        if (Number.isNaN(y) || y < 0) return;
        el.scrollTop = y;
      } catch (e) {
        /* ignore */
      }
    };
    applyScroll();
    const raf = requestAnimationFrame(applyScroll);
    return () => cancelAnimationFrame(raf);
  }, [loading]);

  useEffect(() => {
    const el = sidebarRef.current;
    if (!el) return;
    const onScroll = () => {
      try {
        sessionStorage.setItem(SIDEBAR_SCROLL_KEY, String(el.scrollTop));
      } catch (e) {
        /* ignore */
      }
    };
    el.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      onScroll();
      el.removeEventListener("scroll", onScroll);
    };
  }, []);

  const gymid = localStorage.getItem("loggedUserInfo") && JSON.parse(localStorage.getItem("loggedUserInfo")).gymid;


  // const navigateToVerification = () => {
  //   const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo"));
  //   if (userInfo) {
  //     const verificationUrl = `/verify/email?email=${encodeURIComponent(userInfo?.email)}&business=${encodeURIComponent(userInfo?.gymname)}&gymId=${encodeURIComponent(userInfo?.gymid)}&staffId=${encodeURIComponent(userInfo?._id)}`;
  //     navigate(verificationUrl);
  //   }
  // };




  // // Function to send OTP to email
  // const sendEmailOtp = async () => {
  //   setEmailVerifyLoading(true);
  //   setEmailError("");

  //   try {
  //     const userEmail = JSON.parse(localStorage.getItem("loggedUserInfo"))?.email;
  //     const userName = JSON.parse(localStorage.getItem("loggedUserInfo"))?.name || "";

  //     if (!userEmail) {
  //       setEmailError("Email not found");
  //       setEmailVerifyLoading(false);
  //       return;
  //     }

  //     const response = await emailVerify({ email: userEmail, name: userName + " " + "" });
  //     const resData = await response.json();

  //     if (resData.status !== 200) {
  //       setEmailError(resData.status === 400 ? "Please try again." : "Email verification failed!");
  //       setEmailVerificationStep("initial");
  //     } else {
  //       setEmailError("OTP Sent Successfully");
  //       setEmailSentOtp(resData.otp);
  //       setEmailVerificationStep("otp_sent");
  //       setEmailOtpDigits(["", "", "", "", "", ""]);

  //       setTimeout(() => {
  //         if (otpRefs.current[0]) otpRefs.current[0].focus();
  //       }, 100);

  //       setTimeout(() => setEmailError(""), 3000);
  //     }
  //   } catch (error) {
  //     console.error("Error sending OTP:", error);
  //     setEmailError("Failed to send OTP. Please try again.");
  //   } finally {
  //     setEmailVerifyLoading(false);
  //   }
  // };


  // const verifyEmailOtp = async () => {
  //   const enteredOTP = emailOtpDigits.join("");

  //   if (enteredOTP.length !== 6) {
  //     setEmailError("Please enter valid 6-digit OTP");
  //     return;
  //   }

  //   if (enteredOTP !== emailSentOtp) {
  //     setEmailError("Invalid OTP. Please try again.");
  //     return;
  //   }

  //   setEmailError("OTP verified Successfully");

  //   try {
  //     const gymid = JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid;
  //     const updates = { isemailverified: true };
  //     await saveGBussinessInfo(updates, gymid);

  //     const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo"));
  //     userInfo.isemailverified = true;
  //     localStorage.setItem("loggedUserInfo", JSON.stringify(userInfo));

  //     // Update verification status
  //     setIsEmailVerified(true);

  //     // Close popup immediately
  //     setShowEmailVerifyPopup(false);
  //     setEmailVerificationStep("initial");
  //     setEmailOtpDigits(["", "", "", "", "", ""]);
  //     setEmailSentOtp("");
  //     setEmailError("");

  //     // Show success message
  //     setError2("Email verified successfully!");
  //     setTimeout(() => setError2(""), 3000);

  //   } catch (error) {
  //     console.error("Error updating email verification status:", error);
  //     setEmailError("Failed to update verification status");
  //   }
  // };


  // const handleOtpChange = (index, value) => {
  //   const val = value.replace(/[^0-9]/g, "");
  //   const newOtp = [...emailOtpDigits];
  //   newOtp[index] = val;
  //   setEmailOtpDigits(newOtp);

  //   if (emailError) {
  //     setEmailError("");
  //   }

  //   if (val && index < 5) {
  //     if (otpRefs.current[index + 1]) {
  //       otpRefs.current[index + 1].focus();
  //     }
  //   }
  // };

  // const handleOtpKeyDown = (e, index) => {
  //   if (e.key === 'Backspace' && !emailOtpDigits[index] && index > 0) {
  //     if (otpRefs.current[index - 1]) {
  //       otpRefs.current[index - 1].focus();
  //     }
  //   }
  // };

  // const handleResendOtp = async () => {
  //   setResendLoading(true);
  //   setEmailError("");

  //   try {
  //     const userEmail = JSON.parse(localStorage.getItem("loggedUserInfo"))?.email;
  //     const userName = JSON.parse(localStorage.getItem("loggedUserInfo"))?.name || "";

  //     const response = await emailVerify({ email: userEmail, name: userName + " " + "" });
  //     const resData = await response.json();

  //     if (resData.status !== 200) {
  //       setEmailError(resData.message || "Failed to resend OTP. Try again.");
  //     } else {
  //       setEmailError("OTP resent successfully!");
  //       setEmailSentOtp(resData.otp);
  //       setEmailOtpDigits(["", "", "", "", "", ""]);

  //       setTimeout(() => {
  //         if (otpRefs.current[0]) otpRefs.current[0].focus();
  //       }, 100);

  //       setTimeout(() => setEmailError(""), 3000);
  //     }
  //   } catch (err) {
  //     console.error(err);
  //     setEmailError("Something went wrong");
  //   } finally {
  //     setResendLoading(false);
  //   }
  // };



  // console.log(roleAccess, rolename, 'roleAccess');

  function getMainDomain(hostname) {
    const parts = hostname.split('.');
    if (parts.length >= 2) {
      return parts.slice(-2).join('.');
    }
    return hostname;
  }
  const handleWhatsAppToggle = () => {
    setIsWhatsAppOpen(!isWhatsAppOpen);
  };
  const isActive = (path) => {
    return location.pathname === path;
  };
  const [currentdomain, setCurrentdomain] = useState({})
  async function fetchsubDomains() {


    const Domain = getMainDomain(window.location.hostname);
    const subDomainInfo = await getAllSubDomain(Domain);
    if (!subDomainInfo || subDomainInfo === "false") return;

    const subDomainData = await subDomainInfo.json();
    console.log(subDomainData, '999999999999999999999');
    const matchedDomain = subDomainData?.length > 0 ? subDomainData.find((item) => item.gymid === gymid) : {};
    if (matchedDomain) {
      setCurrentdomain(matchedDomain);
    } else {
      setCurrentdomain({});
    }
  }

  const loggedUser = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")) : "";

  useEffect(() => {
    if (localStorage.getItem("loggedUserInfo")) {
      fetchsubDomains()
    }


    const fetchMData = async () => {
      try {
        const loggedUser = JSON.parse(localStorage.getItem("loggedUserInfo"));
        if (!loggedUser) return;

        const payload = {
          gymid: loggedUser.gymid,
        };

        if (!(loggedUser.rolevalues && loggedUser.rolevalues.includes(1))) {
          payload.staffId = loggedUser._id;
        }

        const response = await getmultigyms(payload);
        if (!response || !response.ok) return;

        const data = await response.json();

        if (!Array.isArray(data)) {
          setMdata([]);
          return;
        }

        // Move current gym to top
        const selectedGymIndex = data.findIndex(
          (business) => business._id === loggedUser.gymid
        );

        if (selectedGymIndex > -1) {
          const selectedGym = data.splice(selectedGymIndex, 1)[0];
          data.unshift(selectedGym);
        }

        setMdata(data);

      } catch (error) {
        console.error("Failed to fetch data:", error);
      }
    };


    if (localStorage.getItem("loggedUserInfo")) {
      fetchMData();
    }
  }, [gymid]);

  // Clear Pine Labs device from localStorage if it belongs to a different gym
  useEffect(() => {
    if (!gymid) return;
    try {
      const stored = localStorage.getItem('pinelabsActiveDevice');
      if (!stored) return;
      const device = JSON.parse(stored);
      if (device._gymId && device._gymId !== gymid) {
        localStorage.removeItem('pinelabsActiveDevice');
      }
    } catch (_) {}
  }, [gymid]);

  const handleSelectChange = async (event) => {
    const selectedId = event.target.value;

    const selectedBusiness = mdata?.find(
      (business) => business._id === selectedId
    );
    if (!selectedBusiness) return;

    const storedUser = JSON.parse(localStorage.getItem("loggedUserInfo"));
    if (!storedUser) return;

    const isOwner = storedUser.rolevalues?.some(
      (r) => Number(r) === 1
    );

    let updatedUser = {
      ...storedUser,
      gymid: selectedBusiness._id,
      gymname:
        selectedBusiness?.displayname && selectedBusiness?.displayname !== ""
          ? selectedBusiness.displayname
          : selectedBusiness.businessName,
      gymlogoUrl: selectedBusiness.logourl,
    };

    try {
      // Only staff calls API
      if (!isOwner) {
        const updates = {
          gymid: selectedBusiness._id,
          email: storedUser.email,
          number: storedUser.number,
        };

        try {
          const response = await getStaffByGym(updates);

          if (response && response.ok) {
            const staffData = await response.json();

            if (staffData?.data?._id) {
              //  Update staff ID if found
              updatedUser._id = staffData.data._id;
            }
          }

          // If API fails or staff not found → do nothing
          // Gym switch still allowed

        } catch (apiError) {
          console.log("Staff API error, switching without changing _id");
        }
      }

      // Always save updated gym info
      localStorage.setItem("loggedUserInfo", JSON.stringify(updatedUser));

      // Log event (unchanged logic)
      let ip = localStorage.getItem("ipaddress");
      let browserinfo = browserName + "-" + browserVersion + ".0.0";
      let Eventtype = "gym-switch";
      let username1 = storedUser?.email || "";

      let flag = `Switched to Gym (${selectedBusiness.businessName})`;

      logEvent(
        {
          Eventtype,
          username1,
          ip,
          flag,
          browserinfo,
          gymid: selectedBusiness._id,
        },
        selectedBusiness._id
      );

      window.location.reload();

    } catch (error) {
      console.error("Gym switch failed:", error);
    }
  };


  useEffect(() => {

    const handleImageLoad = () => {
      setImageLoaded(true);
    };

    const handleImageError = () => {
      setImageLoaded(false);
    };

    const imgElement = document.createElement("img");
    imgElement.onload = handleImageLoad;
    imgElement.onerror = handleImageError;
    imgElement.src = logourl;

    return () => {
      imgElement.onload = null;
      imgElement.onerror = null;
    };
  }, [logourl]);

  useEffect(() => {
    if (plansInfo != null && plansInfo?.feature?.whatsappintegration) {
      if (localStorage.getItem("loggedUserInfo")) {
        fetchWhatsapiData()
      }
    }

  }, [])

  const fetchWhatsapiData = async () => {
    const response = await getWhatsappApi(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid);
    if (!response || response === "false") {
      return;
    }
    const whatsAppapi = await response.json();
    console.log(whatsAppapi, '8888888888886666');
    const filterapi = whatsAppapi.length > 0 && whatsAppapi.filter((item) => item.primary === true)
    // console.log(filterapi);

    if (filterapi.length > 0) {
      setWhatsAppapiCheck(filterapi[0].istokenexpired)
    }

  }

  function closeMenu() {
    setMenuClass(
      "gym-sidebar gym-red gym-top gym-medium gym-padding gym-collapse "
    );
  }
  function showmenu() {
    setMenuClass("gym-sidebar gym-red gym-top gym-medium gym-padding");
  }
  if (plansInfo != null && !plansInfo?.feature?.adminlogin) {
    if (localStorage.getItem("loggedUserInfo") && (roleAccess?.leftpane?.accessinfo?.changeplan == 1)) {
      handleClick();
    }
  }
  // console.log(plansInfo);
  if (plansInfo != null && !plansInfo?.feature?.stafflogin) {
    if (localStorage.getItem("loggedUserInfo") && (!roleAccess?.leftpane?.accessinfo?.changeplan == 1)) {
      handleClick();
    }
  }




  async function handleClick() {
    try {
      // logOutUser(JSON.parse(localStorage.getItem("loggedUserInfo"))._id);
      let ip = localStorage.getItem("ipaddress");
      let browserinfo = browserName + "-" + browserVersion + ".0.0";
      let flag = "Logout Successfull";
      let Eventtype = "login";
      let gymid = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "";
      let username1 = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).email : "";
      let staffid = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo"))._id : "";
      await trackButtonClick("LeftPane", "Staff_Logout", "staff", {});
      await logEvent({ Eventtype, username1, ip, flag, browserinfo, gymid }, gymid);
      const date = new Date()
      console.log(date.toISOString());
      const update = {
        staffid: staffid,
        date: date.toISOString()
      }
      await endBussinessSession(staffid, update);
      sessionStorage.clear();

      localStorage.removeItem("transaction_filter");
      localStorage.removeItem("loggedUserInfo");
      localStorage.removeItem("token");
      localStorage.removeItem("username");
      localStorage.removeItem("password");
      localStorage.removeItem("ipaddress");
      window.location.href = "/login";
      localStorage.removeItem("planInfo");
      localStorage.removeItem("frontEndEnvData");

      //this.context.router.transitionTo('/login');
      //return;
    } catch (e) {
      console.log(e);
    }
  }
  let expiryPlanpopup = false;
  if (plansInfo != null && plansInfo?.planUsage?.status === 0) {
    expiryPlanpopup = true;
  }
  let userInfoInSession = localStorage.getItem("loggedUserInfo") ? true : false;

  function closeWindow() {
    handleClick();
  }

  useEffect(() => {
    const fetchStaffProfile = async () => {
      if (localStorage.getItem("loggedUserInfo")) {
        try {
          const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo"));

          const response = await getStaffProfile(userInfo._id);

          if (!response || response === "false") {
            return;
          }

          const staffProfile = await response.json();

          if (staffProfile) {
            const signupEnabledValue = staffProfile.issignup;
            setIsSignupEnabled(signupEnabledValue);

            if (signupEnabledValue == false) {
              setShowPopup(true);
            }
          }
        } catch (error) {
          console.error("Error fetching staff profile:", error);
        }
      }
    };

    fetchStaffProfile();
  }, []);



  useEffect(() => {
    let getLoggedInGymInfo = async () => {
      try {
        if (localStorage.getItem("loggedUserInfo") === null) {
          navigate("/login");
          return;
        }
      } catch (e) { }
      //return { name: userInfo.gym, loc: userInfo.gymloc };
    };

    if (localStorage.getItem("loggedUserInfo")) {
      getLoggedInGymInfo();
      // fetchData();
    }
    else {
      navigate("/login");
    }
  });

  useEffect(() => {
    setPlansInfo(JSON.parse(localStorage.getItem("planInfo")));
  }, [localStorage.getItem("planInfo")]);

  useEffect(() => {
    const getPricingPlansBYGymid = async () => {
      const response = await getPricingPlansById(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid);
      if (!response || response === "false") {
        return
      }
      const recinfo = await response.json();
      if (recinfo && recinfo.feature) {
        setPlansInfo(recinfo);
        localStorage.setItem("planInfo", JSON.stringify(recinfo));
        setnoPlanpopup(false);
      } else {
        setnoPlanpopup(true);
        localStorage.removeItem("planInfo");
      }
    }
    if (localStorage.getItem("loggedUserInfo")) {
      getPricingPlansBYGymid();
    } else {
      localStorage.removeItem('planInfo');
    }
  }, []);
  useEffect(() => {
    if (!localStorage.getItem("planInfo")) {
      setTimeout(() => {
        setnoPlanpopup(true);
      }, 6000);
    } else {
      setnoPlanpopup(false);
    }
  }, [localStorage.getItem("planInfo")]);
  useEffect(() => {
    const fetchData = async () => {
      if (localStorage.getItem("loggedUserInfo")) {
        const response = await getGBussinessInfo(
          JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
        );
        if (!response || response === "false") {
          return;
        }
        const recinfo = await response.json();

        console.log("recinforecinfo", recinfo)


        // // Update email verification status from API
        // const emailVerifiedStatus = recinfo?.isemailverified;


        // // // Only show popup if email is NOT verified and user has permission
        // if ((emailVerifiedStatus === false || emailVerifiedStatus === "false")
        //   && roleAccess?.leftpane?.accessinfo?.changeplan === 1) {
        //   // console.log("Email not verified, navigateee popup...");
        //   navigateToVerification();
        // }

        if (recinfo) {
          let value = recinfo.isenable != false ? true : false;
          setEnagleGym(value);
        }
      }
    }
    if (localStorage.getItem('ipaddress') == null || localStorage.getItem('ipaddress') == undefined) {
      ipaddress();
    }
    fetchData();
  }, []);

  async function ipaddress() {
    try {
      // const url = 'https://api.ipify.org?format=json';
      const frontEndEnvData = localStorage.getItem("frontEndEnvData");
      const googleMapsApiKeydata = frontEndEnvData ? JSON.parse(frontEndEnvData)?.reactappipaddressurl : "https://api.ipify.org?format=json";
      const url = googleMapsApiKeydata
      const res = await axios.get(url);
      console.log(process.env.REACT_APP_IP_ADDRESS_URL);
      console.log(res.data.ip);
      localStorage.setItem('ipaddress', res.data.ip);
    } catch (error) {
      console.error("Error fetching IP address:", error);
    }
  }

  const handleLinkClick = (event, path) => {
    if (event.ctrlKey) {
      event.preventDefault();
      window.open(path, "_blank");
    } else {
      persistSidebarScroll();
      navigate(path);
    }
  };

  let posValue = true;
  if (plansInfo != null) {
    if (!plansInfo?.planUsage?.transactionflag) {
      posValue = false;
    }
    if (!plansInfo?.planUsage?.activeMembflag) {
      posValue = false;
    }
    if (!plansInfo?.feature?.pos) {
      posValue = false;
    }
  }

  const handleChangePlan = () => {
    navigate("/commercials");
  };
  const days = Math.floor(plansInfo != null ? plansInfo.planUsage.baldays : 0);
  const hours = Math.round(((plansInfo != null ? plansInfo.planUsage.baldays : 0) - days) * 24);

  const handleRenewPlan = async () => {
    if (plansInfo != null) {
      let planid = plansInfo?._id;
      navigate(`/billingmanagementplans?id=${planid}&value=${1}`);
    } else {
      navigate(`/billingmanagementplans`)
    }
  };

  const handleClassDashboardClick = async () => {
    const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo")) || {};
    const gymid = userInfo.gymid || "";
    const username1 = userInfo.email || "user";
    const fullName =
      userInfo.name || `${userInfo.fname || ""} ${userInfo.lname || ""}`.trim() || "User";
    const ip = localStorage.getItem("ipaddress");
    const browserinfo = `${browserName}-${browserVersion}.0.0`;
    const flag = `Class Booking module accessed by (${fullName})`;


    try {
      await logEvent(
        {
          Eventtype: username1,
          username1,
          ip,
          flag,
          browserinfo,
          gymid,
        },
        gymid
      );
    } catch (err) {
      console.error("Logging failed:", err);
    }

    navigate("/classdashboard");
  };

  function formatRoles(rolesArray) {
    return rolesArray.map(role =>
      role.charAt(0).toUpperCase() + role.slice(1)
    ).join(', ');
  }

  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [partnerData, setPartnerData] = useState(null);

  useEffect(() => {
    async function checkRegistrationStatus() {
      try {

        const gymid = JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid;

        if (!gymid) {
          return;
        }

        const partnerResponse = await getwhatsAppPartnerInfo(gymid);

        if (partnerResponse && partnerResponse !== "false") {
          const partnerinfo = await partnerResponse.json();

          if (partnerinfo?.data) {
            // Gym has submitted registration
            setHasSubmitted(true);
            setPartnerData(partnerinfo.data);
          } else {
            // No registration found
            setHasSubmitted(false);
          }
        } else {
          // API error or no data
          setHasSubmitted(false);
        }
      } catch (error) {
        console.error("Error checking registration status:", error);
        setHasSubmitted(false);
      }
    }

    checkRegistrationStatus();
  }, []);

  const whatsAppMenuItems = [
    ...(hasSubmitted
      ? [
        // { id: 1, path: '/whatsapp/dashboard', icon: 'tachometer-alt', label: 'Dashboard' },
        { id: 2, path: '/whatsapp/templates', icon: 'layer-group', label: 'Templates' },
        // { id: 3, path: '/whatsapp/campaign', icon: 'users', label: 'Campaign' },
        { id: 4, path: '/whatsapp/leads', icon: 'comment-alt', label: 'Leads', beta: true },
        // { id: 4, path: '/whatsapp/messages', icon: 'comment-alt', label: 'Messages' },
        // { id: 5, path: '/whatsapp/broadcast', icon: 'bullhorn', label: 'Broadcast' },
        // { id: 6, path: '/whatsapp/automation', icon: 'robot', label: 'Automation' },
        // { id: 7, path: '/whatsapp/analytics', icon: 'chart-bar', label: 'Analytics' },
        // { id: 8, path: '/whatsapp/settings', icon: 'cog', label: 'Settings' },
      ]
      : []),
    { id: 9, path: '/whatsapp/connect', icon: 'plug', label: 'Connect' },
  ];
  return (
    <>
      <header className="gym-container gym-top gym-hide-large gym-red gym-xlarge gym-padding">
        <button
          onClick={showmenu}
          className="gym-button gym-red gym-margin-right button-link"
        >
          <MDBIcon fas icon="bars" />
        </button>
        <h5 className='ms-3 mb-0 d-inline'>EasyMembr</h5>
      </header>
      <nav
        ref={sidebarRef}
        className={menuClass}
        style={{ zIndex: 11, width: "320px" }}
        id="mySidebar"
        onClickCapture={persistSidebarScroll}
      >

        <button
          onClick={closeMenu}
          className="gym-button gym-hide-large gym-display-topleft button-link"
        >
          <MDBIcon fas icon="close" className='close-icon-m' onClick={closeMenu} />
        </button>
        <img
          src={imageLoaded ? logourl : logo}
          className="logoImg ms-2"
          alt="logo"
        />
        <div className="user-info">
          <h5 className="mx-2 pt-3 title">

            <MDBTooltip tag='div' placement="bottom"
              title={
                bussName !== "" ? bussName : ""}
            > {bussName !== "" ? bussName : ""}
            </MDBTooltip>
          </h5>
          {userInfoInSession &&

            <div className='d-flex flex-wrap mb-3'>
              {JSON.parse(localStorage.getItem("loggedUserInfo")).name ? <p className="expiry mx-1 mb-0 chip bg-secondary bg-opacity-50">
                {JSON.parse(localStorage.getItem("loggedUserInfo")).name}
              </p> : null}
              {rolename ?
                <p className="expiry mx-1 mb-0 title chip bg-info bg-opacity-50">
                  {formatRoles(rolename)}
                </p> : null}
              {(plansInfo != null)
                ? <>
                  <p className="expiry mx-1 mb-0 chip bg-success bg-opacity-50">{plansInfo.name}
                    {roleAccess?.leftpane?.accessinfo?.changeplan == 1 &&
                      <button
                        className="button-link fw-600 px-1 text-primary fs-10px"
                        onClick={handleRenewPlan}
                        style={{ pointerEvents: "auto" }}
                      >
                        Change Plan
                      </button>}
                  </p>
                </>
                : <></>}
            </div>}


          {plansInfo != null && !(plansInfo?.planUsage?.lifetimefree) ? (
            (plansInfo.planUsage.baldays <= 0) ?
              <button onClick={roleAccess?.leftpane?.accessinfo?.changeplan == 1 ? handleRenewPlan : undefined} title='Renew plan'
                className="btn btn-danger my-1 mx-1 w-100" style={{ pointerEvents: "auto" }}>
                Plan Expired/Renew
              </button>
              :
              ((plansInfo.planUsage.baldays <= 10) ?
                <button onClick={roleAccess?.leftpane?.accessinfo?.changeplan == 1 ? handleRenewPlan : undefined} className="btn btn-warning my-1 mx-1 w-100" style={{ pointerEvents: !roleAccess?.leftpane?.accessinfo?.changeplan == 1 ? "none" : "auto" }}>
                  Renew in {days == 0 ? <>{hours} hour(s)</> : <>{days} day(s)</>}
                </button>
                :
                <button onClick={roleAccess?.leftpane?.accessinfo?.changeplan == 1 ? handleRenewPlan : undefined}
                  title='Renew plan'
                  className="btn btn-primary my-1 mx-1 w-100" style={{ pointerEvents: !roleAccess?.leftpane?.accessinfo?.changeplan == 1 ? "none" : "auto" }}>
                  Renew in {days} day(s)
                </button>
              )
          ) : ""}
        </div>


        <div style={{ height: "40px" }}>
          {Array.isArray(mdata) && mdata.length > 1 && (
            <div className='select-wrapper' >
              <div className='form-outline'>
                <select
                  style={{ lineHeight: "1.2", marginBottom: "0.5rem" }}
                  id="business-dropdown form-control-sm"
                  className="form-select "
                  onChange={handleSelectChange}
                  defaultValue={selectedGym}
                  value={selectedGym}
                >
                  {mdata.map((business) => (
                    <option key={business._id} value={business._id}>
                      {business?.displayname && business?.displayname != "" ? business?.displayname : business.businessName}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}
        </div>


        <div className='d-flex flex-column justify-content-between leftpanelHeigt '>
          <div className="gym-bar-block">
            {plansInfo == null || (plansInfo !== null && plansInfo?.feature?.dashboard) && roleAccess?.dashboard?.access &&
              <Link
                id="hs-bp"
                to="/dashboard"
                onClick={(event) => handleLinkClick(event, '/dashboard')}
                className={`gym-bar-item gym-button gym-hover-white ${props.isactive === "11" ? "active" : ""
                  }`}
              >
                <img src={dashImg} alt="Logo" /> Dashboard
              </Link>}

            {plansInfo == null || posValue && roleAccess?.pointofsale?.access &&
              <Link
                id="hs-home"
                to="/home"
                onClick={(event) => handleLinkClick(event, '/home')}
                className={`gym-bar-item gym-button gym-hover-white ${props.isactive === "1" ? "active" : ""
                  }`}
              >
                <img src={posImg} alt="Logo" /> Point of Sale
              </Link>}
            {userInfoInSession && roleAccess?.businessinfo?.access &&
              <Link
                id="hs-bp"
                to="/bInfo"
                state={{ mdata }}
                onClick={(event) => handleLinkClick(event, '/bInfo')}
                className={`gym-bar-item gym-button gym-hover-white ${props.isactive === "2" ? "active" : ""
                  }`}
              >
                <img src={businessImg} alt="Logo" /> Business Details
              </Link>
            }
            {roleAccess?.membersmanagement?.access &&
              <Link
                id="hs-mmanger"
                to="/mmanager"
                onClick={(event) => handleLinkClick(event, '/mmanager')}
                className={`gym-bar-item gym-button gym-hover-white ${props.isactive === "3" ? "active" : ""
                  }`}
              >
                <img src={membersImg} alt="Logo" /> Members Management
              </Link>}
            {plansInfo == null || (plansInfo !== null && plansInfo?.feature?.membercheckin) && roleAccess?.checkin?.access &&
              <Link
                to="/checkin"
                id="checkin"
                onClick={(event) => handleLinkClick(event, '/checkin')}
                className={`gym-bar-item gym-button gym-hover-white ${props.isactive === "5" ? "active" : ""}`}
              >
                <img src={checkImg} alt="Logo" /> Check-In/Check-Out
              </Link>
            }
            <Link
              to="/report"
              id="/report"
              onClick={(event) => handleLinkClick(event, '/report')}
              className={`gym-bar-item gym-button gym-hover-white ${props.isactive === "13" ? "active" : ""}`}>
              <img src={report} alt="Logo" /> Reports
            </Link>
            <Link
              to="/staff#"
              id="staff"
              onClick={(event) => handleLinkClick(event, '/staff')}
              className={`gym-bar-item gym-button gym-hover-white ${props.isactive === "6" ? "active" : ""
                }`}
            >
              <img src={staffImg} alt="Logo" /> Staff Roles & Attendance
            </Link>
            <Link
              to="/plansandaddons"
              id="about-me"
              onClick={(event) => handleLinkClick(event, '/plansandaddons')}
              className={`gym-bar-item gym-button gym-hover-white ${props.isactive === "7" ? "active" : ""
                }`}
            >
              <img src={memShipImg} alt="Logo" /> Plans, Slots & Addons
            </Link>

            <Link
              to="/transactions"
              id="transaction"
              onClick={(event) => handleLinkClick(event, '/transactions')}
              className={`gym-bar-item gym-button gym-hover-white ${props.isactive === "8" ? "active" : ""
                }`}
            >
              <img src={transcImg} alt="Logo" /> Transactions
            </Link>
            {roleAccess?.activities?.access &&
              <Link
                to="/logEvent"
                id="logEvent"
                onClick={(event) => handleLinkClick(event, '/logEvent')}
                className={`gym-bar-item gym-button gym-hover-white ${props.isactive === "12" ? "active" : ""
                  }`}
              >
                <img src={event} alt="Logo" /> Activities
              </Link>}
            {roleAccess?.yourwebsite?.access &&
              <Link
                to="/gymtemplate"
                id="gymtemplate"
                onClick={(event) => handleLinkClick(event, '/gymtemplate')}
                className={`gym-bar-item gym-button gym-hover-white ${props.isactive === "15" ? "active" : ""
                  }`}
              >
                <img src={globeImg} alt="Logo" /> Your Website
              </Link>}
            {roleAccess?.templatesandreminders?.access &&
              <Link
                id="hs-receipts"
                to="/messageSettings"
                onClick={(event) => handleLinkClick(event, '/messageSettings')}
                className={`gym-bar-item gym-button gym-hover-white ${props.isactive === "4" ? "active" : ""
                  }`}
              >
                <img src={remaindersImg} alt="Logo" /> Templates & Reminders {whatsAppapiCheck && <i class="fas fa-triangle-exclamation text-warning"></i>}
              </Link>}

            {/* <Link
              id="hs-receipts"
              to="/segments&campaigns"
              onClick={(event) => handleLinkClick(event, '/segments&campaigns')}
              className={`gym-bar-item gym-button gym-hover-white ${props.isactive === "15" ? "active" : ""
                }`}
            >
              <img src={SegmentsIcon} alt="Logo" /> Segmentation & Campaign
            </Link> */}

            <div className='my-1'>
              <button
                className={`nav-link text-start d-flex justify-content-between align-items-center w-100 p-1 ps-2 ${props.isactive === "16" ? "" : ""}`}
                onClick={handleWhatsAppToggle}
                aria-expanded={isWhatsAppOpen}
                aria-controls="whatsapp-collapse"
              >
                <span>
                  <MDBIcon size='xl' fab icon="whatsapp" className=" me-2" />
                  WhatsApp
                </span>
                <MDBIcon icon={`chevron-${isWhatsAppOpen ? 'up' : 'down'}`} />
              </button>

              <MDBCollapse show={isWhatsAppOpen} open={isWhatsAppOpen} id="whatsapp-collapse">
                <div className=" rounded mt-1 ps-3" >
                  {whatsAppMenuItems.map((item) => (
                    <Link
                      key={item.id}
                      to={item.path}
                      style={{ fontSize: '13px' }}
                      className={`nav-link d-flex align-items-center rounded-end p-2 ${isActive(item.path) ? 'active bg-white text-dark' : ''}`}
                    >
                      <MDBIcon icon={item.icon} className="me-2 flex-shrink-0" />
                      <span className="d-inline-flex align-items-center gap-2 flex-wrap">
                        {item.label}
                        {item.beta ? (
                          <MDBBadge pill light color="primary" className="text-uppercase" style={{ fontSize: '0.6rem', letterSpacing: '0.03em' }}>
                            Beta
                          </MDBBadge>
                        ) : null}
                      </span>
                    </Link>
                  ))}
                </div>
              </MDBCollapse>
            </div>
            {roleAccess?.manageaccount?.access &&
              <Link
                to="/settingview"
                id="settings"
                onClick={(event) => handleLinkClick(event, '/settingview')}
                className={`gym-bar-item gym-button gym-hover-white ${props.isactive === "9" ? "active" : ""
                  }`}
              >
                <img src={settingsImg} alt="Logo" /> Manage Account
              </Link>}
            <div className={`subtab-link gym-bar-item gym-button gym-hover-white ${props.isactive === "14" ? "active" : ""
              }`}  >

              <MDBAccordion initialActive={1}>
                <MDBAccordionItem className='sub-tab' collapseId={2} headerTitle={<><i class="fas fa-hand-holding-heart"></i>Modules</>}>
                  <ul className='list-unstyled m-0'>
                    <li className='sublist' onClick={handleClassDashboardClick}><Link to="/classdashboard" className='ps-3'>EasyBook</Link> </li>
                    {/* <li className='sublist' onClick={() => navigate("/login")}>Mebar Management</li> */}
                  </ul>
                </MDBAccordionItem>
              </MDBAccordion>

            </div>
            <Link
              onClick={handleClick}
              id="settings"

              className={`gym-bar-item gym-button gym-hover-white ${props.isactive === "10" ? "active" : ""
                }`}
            >
              <img src={logOutImg} alt="Logo" /> Logout
            </Link>
          </div>


          <div className="PoweredTxt">
            <span className='d-block text-secondary'>Powered by</span>
            <b className='d-block fs-6'>EasyMembr</b>
          </div>
        </div>
      </nav >
      {
        userInfoInSession ? (
          JSON.parse(localStorage.getItem("loggedUserInfo")).isemailverifed
          &&
          (JSON.parse(localStorage.getItem("loggedUserInfo")).isemailverifed ===
            "0" && roleAccess?.leftpane?.accessinfo?.changeplan == 1) && (
            <>
              <Popup
                title="Please verify your email to continue"
                ptype="modal-md"
                content={
                  <>
                    <div style={{ textAlign: "center" }}>
                      <img src={sucessImg} alt='logo' />
                    </div>
                    <div className="thanksmain mt40">
                      Instructions for registering for Business have been sent to{" "}
                      <b>
                        {
                          JSON.parse(localStorage.getItem("loggedUserInfo"))
                            .email
                        }
                      </b>
                      . Kindly check your spam folder if you have not received the
                      email
                    </div>
                    <br />
                    <div className="thanksmain">
                      Email not received? <br />
                      <button className="btn btn-primary mt10 button-link">
                        Resend
                      </button>
                      &nbsp;

                    </div>
                  </>
                }
                handleClose={closeWindow}
              />
            </>
          )) : ""
      }


      {
        showPopup && (
          <MDBModal open={showNewPasswordPop} onClose={() => setShowNewPasswordPop(false)} tabIndex="-1">
            <MDBModalDialog>
              <MDBModalContent>
                <MDBModalHeader>
                  <MDBModalTitle>Create New Password</MDBModalTitle>
                  <MDBBtn className="btn-close" color="none" onClick={() => setShowNewPasswordPop(false)}></MDBBtn>
                </MDBModalHeader>
                <MDBModalBody>

                  <GenerateNewPassword
                    onSuccess={() => {
                      setShowNewPasswordPop(false);
                      setError2("Password successfully changed.");
                    }}
                  />
                </MDBModalBody>
              </MDBModalContent>
            </MDBModalDialog>
          </MDBModal>
        )
      }

      <MDBAlert
        color={
          (Error2.includes("internet") || Error2.includes("wrong"))
            ? "danger"
            : (Error2.includes("submitted") ||
              Error2.includes("changed") ||
              Error2.includes("Email verified successfully!"))
              ? "success"
              : "secondary"
        } autohide
        position="top-center"
        delay={5000}
        appendToBody
        open={Error2 !== ""}
        onClose={() => setError2("")}
      >
        {Error2}
      </MDBAlert >

      {
        noPlanpopup && (<>
          <Popup
            title="Plan Subscription"
            ptype="modal-md"
            style=""
            content={
              <>
                Seems you haven't subscribed yet! Subscribe for more features.
                <MDBModalFooter className="pe-2 pb-2">
                  <MDBBtn color='secondary' onClick={() => handleClick()}>Cancel</MDBBtn>
                  <MDBBtn onClick={roleAccess?.leftpane?.accessinfo?.changeplan == 1 ? handleRenewPlan : undefined}
                    style={{ pointerEvents: !roleAccess?.leftpane?.accessinfo?.changeplan == 1 ? "none" : "auto" }}>
                    Subscribe</MDBBtn>
                </MDBModalFooter>
              </>
            }
            handleClose={() => handleClick()}
          />
        </>
        )
      }
      {
        expiryPlanpopup && (
          <>
            <Popup
              title="Renew Subscription"
              ptype="modal-md"
              style=""
              content={
                <>
                  <div className='pb-2'>
                    Oops! Your subscription Plan has expired.
                    {userInfoInSession && (!roleAccess?.leftpane?.accessinfo?.changeplan == 1)
                      ? "" : " Please renew for uninterrupted service."}
                  </div>
                  <MDBModalFooter className="pe-2 pb-2">
                    <MDBBtn color='secondary' onClick={() => handleClick()}>Cancel</MDBBtn>
                    <MDBBtn onClick={handleRenewPlan} style={{
                      pointerEvents: userInfoInSession && !roleAccess?.leftpane?.accessinfo?.changeplan == 1 ? "none" : "auto"
                    }}>Renew</MDBBtn>
                  </MDBModalFooter>
                </>
              }
              handleClose={() => handleClick()}
            />
          </>
        )
      }

      {/* Email Verification Popup with Individual OTP Inputs */}
      {
        // showEmailVerifyPopup && roleAccess?.leftpane?.accessinfo?.changeplan == 1 && (
        //   <Popup
        //     title="Email Verification Required"
        //     ptype="modal-md"
        //     style=""
        //     content={
        //       <div className="text-center">
        //         {emailVerificationStep === "initial" && (
        //           <>
        //             <div style={{ textAlign: "center" }}>
        //               <MDBIcon fas icon="envelope" size="3x" className="text-warning mb-3" />
        //             </div>
        //             <label className="mb-3">
        //               Please verify your email address to continue using all features.
        //               <br />
        //               <strong>{JSON.parse(localStorage.getItem("loggedUserInfo"))?.email}</strong>
        //             </label>

        //             <p className="my-3 fs-14px">
        //               We'll send a One Time Password (OTP) to your registered email address.
        //               <br />
        //               Enter the OTP to verify your email.
        //             </p>

        //             <MDBBtn
        //               block
        //               className="mt-2"
        //               onClick={sendEmailOtp}
        //               disabled={emailVerifyLoading}
        //             >
        //               {emailVerifyLoading ? (
        //                 <>
        //                   <MDBSpinner size="sm" className="me-2" />
        //                   Sending...
        //                 </>
        //               ) : (
        //                 "Send OTP"
        //               )}
        //             </MDBBtn>
        //           </>
        //         )}

        //         {emailVerificationStep === "otp_sent" && (
        //           <>
        //             <div style={{ textAlign: "center" }}>
        //               <MDBIcon fas icon="key" size="3x" className="text-primary mb-3" />
        //             </div>
        //             <label className="mb-3">
        //               Enter the OTP sent to<br />
        //               <strong>{JSON.parse(localStorage.getItem("loggedUserInfo"))?.email}</strong>
        //             </label>

        //             {/* Individual OTP Input Boxes */}
        //             <div className="d-flex justify-content-center gap-2 mb-3">
        //               {emailOtpDigits.map((digit, index) => (
        //                 <input
        //                   key={index}
        //                   ref={(el) => (otpRefs.current[index] = el)}
        //                   type="text"
        //                   maxLength={1}
        //                   className="form-control text-center"
        //                   style={{ width: "45px", fontSize: "1.5rem", fontWeight: "bold" }}
        //                   value={digit}
        //                   onChange={(e) => handleOtpChange(index, e.target.value)}
        //                   onKeyDown={(e) => handleOtpKeyDown(e, index)}
        //                 />
        //               ))}
        //             </div>

        //             <div className="d-flex gap-2 justify-content-center">
        //               <MDBBtn
        //                 color="secondary"
        //                 onClick={() => {
        //                   setEmailVerificationStep("initial");
        //                   setEmailOtpDigits(["", "", "", "", "", ""]);
        //                 }}
        //               >
        //                 Back
        //               </MDBBtn>
        //               <MDBBtn
        //                 color="primary"
        //                 onClick={verifyEmailOtp}
        //               >
        //                 Verify OTP
        //               </MDBBtn>
        //             </div>

        //             <p className="text-muted mt-3">
        //               Didn't receive OTP?{" "}
        //               <label
        //                 onClick={handleResendOtp}
        //                 className="button-link fw-600 text-primary fs-14px"
        //                 style={{ cursor: "pointer" }}
        //               >
        //                 {resendLoading ? "Sending..." : "Resend OTP"}
        //               </label>
        //             </p>
        //           </>
        //         )}

        //         {emailVerificationStep === "verified" && (
        //           <>
        //             <div style={{ textAlign: "center" }}>
        //               <MDBIcon fas icon="check-circle" size="3x" className="text-success mb-3" />
        //             </div>
        //             <label className="mb-3">
        //               Email verified successfully!
        //             </label>
        //             <p className="my-3 fs-14px">
        //               Your email has been verified. You can now access all features.
        //             </p>
        //           </>
        //         )}

        //         {emailError && (
        //           <div className={`mt-3 ${emailError.toLowerCase().includes('success') ? 'text-success' : 'text-danger'}`}>
        //             {emailError}
        //           </div>
        //         )}
        //       </div>
        //     }
        //     handleClose={() => {
        //       setShowEmailVerifyPopup(false);
        //       setEmailVerificationStep("initial");
        //       setEmailOtpDigits(["", "", "", "", "", ""]);
        //       setEmailSentOtp("");
        //       setEmailError("");
        //     }}
        //   />
        // )
      }

    </>
  );
}